<template>
  <div class="box-a">
    <p class="under">DISCRETIONARY</p>
    <div v-if="component.props?.description" v-html="safeDescription" />
    <RadioButton
      v-model="choice"
      :input-id="`boxA-${component.id}`"
      value="a"
      :disabled="disabled"
      @update:model-value="onChoose"
    />
    <label :for="`boxA-${component.id}`" style="margin-left: 8px;">
      <strong>{{ component.props?.label || 'Box A' }}</strong>
    </label>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import RadioButton from 'primevue/radiobutton'
import DOMPurify from 'dompurify'

const props = defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
})

const disabled = computed(() => props.mode !== 'vote')
const questionId = computed(() => props.component.props?.questionId)

const safeDescription = computed(() =>
  DOMPurify.sanitize(props.component.props?.description || ''),
)

const choice = computed({
  get() {
    return props.form?.answers?.[questionId.value]?.choice || null
  },
  set(v) {
    if (!props.form || !questionId.value) return
    if (!props.form.answers[questionId.value]) {
      props.form.answers[questionId.value] = { choice: null, directed: {} }
    }
    props.form.answers[questionId.value].choice = v
  },
})

function onChoose() {
  // Picking Box A clears any directed totals for this question.
  if (!props.form || !questionId.value) return
  const ans = props.form.answers[questionId.value]
  if (ans) {
    for (const key of Object.keys(ans.directed || {})) {
      ans.directed[key] = 0
    }
  }
}
</script>

<style scoped>
.box-a {
  padding: 10px 0;
}
.under {
  text-decoration: underline;
  font-weight: 700;
  margin-bottom: 8px;
}
</style>
